import React from "react";
import { dash, formatDDMMYYYY } from "@/lib/documentUtils";

/**
 * Adjournment Application — wording follows the uploaded PDF.
 * Uses "Advocate Appearing For" (+ party number) for all role references.
 */
export const AdjournmentApplication = React.forwardRef(function AdjournmentApplication(
  { data },
  ref,
) {
  const {
    caseNo, courtName, courtPlace,
    party1Name, party2Name, party1Role, party2Role,
    advocateName, date,
    adjournmentReason,
    advocateAppearingFor, advocateAppearingNumber,
  } = data;

  const appearLabel = `${dash(advocateAppearingFor, "Defendant")}${
    advocateAppearingNumber ? ` No. ${advocateAppearingNumber}` : ""
  }`;
  const appearShort = dash(advocateAppearingFor, "Defendant");
  const filedDate = formatDDMMYYYY(date);

  return (
    <div ref={ref} className="a4-sheet adj-sheet" data-testid="adjournment-doc">
      <div className="memo-case-row">
        <div className="memo-case-spacer" />
        <div className="memo-case-no-right" data-testid="adj-case-no">
          {dash(caseNo, "Reg. _____________ No. ____ / _______")}
        </div>
      </div>

      <h2 className="doc-court-heading">IN THE COURT OF {dash(courtName, "_____________________")}</h2>
      <h3 className="doc-court-at">AT- {dash(courtPlace, "_____________________")}</h3>

      <div className="party-block">
        <div className="pb-row">
          <div className="pb-name">{dash(party1Name, "____________________")}</div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            Appellant / Applicant
            <br />
            Complainant / Petitioner
          </div>
        </div>
        <div className="pb-vs">V/s</div>
        <div className="pb-row">
          <div className="pb-name">{dash(party2Name, "____________________")}</div>
          <div className="pb-brace">{"}"}</div>
          <div className="pb-role">
            Respondent / Opponent
            <br />
            Accused / Defendant
          </div>
        </div>
      </div>

      <div className="doc-body adj-body">
        <p className="doc-intro-line">
          The <strong>{appearLabel}</strong> most respectfully submits as under:
        </p>

        {adjournmentReason && adjournmentReason.trim().length ? (
          <p style={{ whiteSpace: "pre-wrap" }}>
            {adjournmentReason.trim()}
          </p>
        ) : (
          <>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;That the necessary documents and relevant information in
              the present matter have not yet been received by the {appearShort}. Hence, it
              has become difficult for the {appearShort} to file the Written Statement and
              place his submissions on record in the present proceedings.
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;The {appearShort}, therefore, most humbly prays that this
              Hon&apos;ble Court may kindly be pleased to grant one adjournment to enable the{" "}
              {appearShort} to file his Written Statement and submissions.
            </p>
          </>
        )}
      </div>

      <div className="adj-foot">
        <div className="adj-foot-left">
          <div>Place: {dash(courtPlace, "____________")}</div>
          <div>Date: {filedDate}</div>
        </div>
        <div className="adj-foot-right">
          <div className="sig-line en-no-line" aria-hidden="true" />
          <div className="sig-label">
            Advocate For {appearShort}
            {advocateName ? (
              <>
                <br />
                Adv. <strong>{advocateName}</strong>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export default AdjournmentApplication;
